<template>
    <div class="message_wrapper" :class="extra_class">
        <transition name="fade">
            <div class="message_container" v-show="show_message" :class="class_set">
                <p class="form_message"  v-html="formatted_message"></p>
            </div>
        </transition>
    </div>
</template>

<script>
    export default {
        name: "DisplayMessage",
        props: ['option'],
        data() {
            let option = this.option;

            let data_set = {
                animate_scroll_top: false,
                show_message: false,
                cache_message: '',
                message: option.message?option.message:'',
                message_type: option.message_type?option.message_type:'',       // ''-default blue text;'success'-green text;'warning'-orange text,'error'-red text;
                extra_class: option.extra_class?option.extra_class:[],
                time_out: option.time_out?option.time_out:15000,
                scroll_top_container: option.scroll_top_container?option.scroll_top_container:$('html, body'),
                clear_time_out: null,

            };

            return data_set;
        } ,
        computed: {
            class_set: function () {
                let current_object = this;
                let class_set = [];
                if (typeof current_object.option.message_type !== 'undefined' && current_object.message_type != current_object.option.message_type) {
                    current_object.message_type = current_object.option.message_type;
                }
                switch (current_object.message_type) {
                    case 'success':
                        class_set.push('message_container_success');
                        break;
                    case 'warning':
                        class_set.push('message_container_warning');
                        break;
                    case 'error':
                        class_set.push('message_container_error');
                        break;
                }

                return class_set;
            },
            formatted_message: function () {
                // Every time option.message changes, this will be triggered, message will be shown for given (time_out) milliseconds
                // Note that if same option.message received, shown time wont be refreshed, message wont display again
                // Solution: define a new array for messages to trigger this again
                let current_object = this;

                current_object.message = current_object.option.message;
                current_object.show_message = !!current_object.message;
// console.log('allen debug root formatted_message computed',current_object.message,current_object.show_message);

                if (!current_object.option || !current_object.option.message) {
                    return '';
                }

                let result = '';
                if (typeof current_object.message === 'string') {
                    result = current_object.message;
                } else {
                    if (current_object.message.length) {
                        result = '<ul>';
                        current_object.message.forEach(function (message_line) {
                            result += '<li>'+message_line+'</li>';
                        });
                        result += '</ul>';
                    } else {
                        current_object.show_message = false;
                    }
                }
                if (current_object.cache_message !== result) {
                    current_object.cache_message = result;
                    current_object.animate_scroll_top = true;
                }
// console.log('allen debug scroll_top_container', current_object.scroll_top_container);
                // current_object.scroll_top_container.scrollTop($(current_object.$el).offset().top - 50);
                if (current_object.show_message && current_object.animate_scroll_top) {
                    current_object.scroll_top_container.stop().animate({
                        scrollTop:$(current_object.$el).offset().top - 20
                    }, 550, 'swing', function () {
                        // When message box display for the first time, container does not exist and scroll to position would be the bottom of container instead of top
                        // (calculated top position number is correct, it is kind of browser render problem)
                        // Do scrollTop again after 0.5s (vue fade-in animate time by css) would fix the problem
                        scrollTop:$(current_object.$el).offset().top - 20;
                        current_object.animate_scroll_top = false;
                    });
                }

                if (current_object.clear_time_out) {
                    clearTimeout(current_object.clear_time_out);
                }
                if (current_object.option.time_out) {
                    current_object.time_out = current_object.option.time_out;
                }
                if (current_object.time_out > 0) {
                    current_object.clear_time_out = setTimeout(function () {
                        current_object.show_message = false;
                        current_object.message_type = '';
                    },current_object.time_out);
                }

                return result;
            }
        }
    }
</script>